import { render, staticRenderFns } from "./communityReward.vue?vue&type=template&id=d7ba3a82"
import script from "./communityReward.vue?vue&type=script&lang=js"
export * from "./communityReward.vue?vue&type=script&lang=js"
import style0 from "./communityReward.vue?vue&type=style&index=0&id=d7ba3a82&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports